import { render } from "./menuConfig.vue?vue&type=template&id=8f1cae7e&scoped=true&ts=true"
import script from "./menuConfig.vue?vue&type=script&lang=ts"
export * from "./menuConfig.vue?vue&type=script&lang=ts"

import "./menuConfig.vue?vue&type=style&index=0&id=8f1cae7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1cae7e"]])

export default __exports__